import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_fykXTTHQMvwt: {
	id: 'prd_fykXT2DEV2THQMvwt'
	ident: 'prd_fykXTTHQMvwt'
	sku: 'simple_premium_1w_5_19_1m_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_TlByz2DEV2oNQb5oD'
			amount: 22
			amount_usd: 5.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 5.19
			discount: 16.81
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_NeKV52DEV2viuU2sK'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_fykXTTHQMvwt, SubscriptionProduct>
const prd_fykXTTHQMvwt = { ident: 'prd_fykXTTHQMvwt' } as typeof _prd_fykXTTHQMvwt

export default prd_fykXTTHQMvwt
